import styled from 'styled-components';
import camera from '../../assets/images/camera.svg';

const StyledContainer = styled.div`
	position: relative;
	z-index: 10;
	display: grid;
	grid-template-columns: 60px 1fr 60px;
	align-items: center;
	gap: 20px;
	width: 320px;
	margin: 14px auto 0 auto;
`;

const StyledDynamicIsland = styled.div`
	position: relative;
	width: 120px;
	height: 30px;
	margin: 0 auto;
	background: #000000;
	border-radius: 40px;
`;

const StyledCamera = styled.div`
	position: absolute;
	left: 4px;
	top: 4px;
	width: 22px;
	height: 22px;
	background-image: url(${camera});
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledCamera,
	StyledContainer,
	StyledDynamicIsland,
	StyledRightContainer,
};
